<template>
  <div class="material-wrapper modular">
    <div class="section-header">
      <el-input
      class="modular_search"
      v-model="search_content"
      :placeholder="$t('view_left_sidebar_module_add_material_228')"
      prefix-icon="el-icon-search"
      @input="search"
    >
    <i slot="suffix" v-show="search_content" class="el-icon-close" @click="clear"></i>
    </el-input>
      <ul class="tab-header" v-show="!search_content">
        <li v-for="(item, index) in tabList" :key="item.value"
            @click="onClickTabItem(item,index)"
            :class="{'tab-item':true,'tab-item-current':index==currentTabIndex,}">{{ $t(item.label) }}
        </li>
      </ul>
    </div>
    <div class="section-content" v-loading="listLoading">
      <div v-for='(item) in list' :key="item.id" class="material-item add_module_layout" data-make="add_material"
      @mouseenter="edit_show(item.id)"
      @mouseleave="edit_show('')"
           :data-type="isEmptyTemplate?'empty':'normal'" :data-id="item.id" data-name="material">
        <div class="img-wrapper add_module_box" @click="onClickUseBtn(item)" >
          <div class="material-name">{{item.group_name}}</div>
          <img :src="item.img + '?w=300'"/>
        </div>
        <div class="btn-group" v-if="cur_materialId == item.id">
          <el-button size="mini" type="primary" icon="el-icon-document" @click="onClickUseBtn(item)">{{$t('view_left_sidebar_module_add_material_229')}}</el-button>
          <el-button size="mini" type="primary" class="preview-btn" icon="el-icon-view" @click="onClickPreviewBtn(item)">{{$t('view_public_topbar_9')}}</el-button>
          <el-button v-if="canDelete(item)" size="mini" type="danger" icon="el-icon-delete" class="my-btn-delete"
                     @click="onClickDeleteBtn(item)">{{$t('view_god_set_index_226')}}</el-button>
        </div>
        <div class="material_thumb_mask" v-if="cur_materialId == item.id"></div>
      </div>
      <div class="bottom-line"><span class="bottom-text">{{$t('view_left_sidebar_module_add_material_230')}}</span></div>
    </div>
    <el-dialog
      :title="currentMaterial.group_name"
      :visible.sync="previewDialogVisible"
      width="1000px"
      :modal-append-to-body="false">
      <div class="preview-wrapper" v-loading="detailLoading">
        <template v-if="isEmptyTemplate">
          <div class="preview-img-wrapper">
            <img class="img-preview" :src="previewImg" alt="">
          </div>
        </template>
        <template v-else>
          <template v-if="Array.isArray(detail)">
            <layout_row v-for="(row, index) in detail" :key="row.widget_id" :row="row" :material_tag="true"></layout_row>
          </template>
          <layout_row v-if="!Array.isArray(detail) && detail" :row="detail" :material_tag="true"></layout_row>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewDialogVisible = false">{{$t('view_public_topbar_14')}}</el-button>
        <el-button type="primary" @click="onClickConfirmUseBtn">{{$t('view_left_sidebar_module_add_material_231')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import layout_row from '@/widgets/layout_row/index.vue';
import {get_material, get_material_detailed, del_material} from '@/api/app';
import Store from "../../../vuex/store";
import Row from "../../../base/one_row";
import Col from "../../../base/one_column";
import emptyTemplateConfig from './emptyTemplateConfig'
import {mydebounce} from "@/base/base";
import {debounce} from "throttle-debounce";

let infoData = {}
export default {
  name: "left_sidebar_add_material",
  components: {layout_row},
  data() {
    return {
      cur_materialId: '',
      currentTabIndex: 0,
      currentTabValue: '',
      tabList: [],
      list: [],
      emptyTemplateList: [],
      currentMaterial: {},
      detail: null,
      previewDialogVisible: false,
      listLoading: false,
      detailLoading: false,
      previewImg: '',
      myMaterialId: '99',
      myMaterialName: i18n.t('view_left_sidebar_module_add_material_232'),
      search_content: "",
      emptyTemplatePath: "/static/image/empty_template/",
      emptyTemplatePathEn: '/static/image/empty_template_en/',
      emptyTemplatePathTc: '/static/image/empty_template_tc/'
    }
  },
  computed: {
    isEmptyTemplate() {
      return this.currentTabValue === 'empty'
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },

    isDesigner() {
      return this.$store.state.app.role == 'designer'
    },
    emptyTemplateVisible() {
      return this.isDesigner || !this.isFullPage
    },
  },
  methods: {
    search() {
      this.debounceGetMaterialList()
    },
    debounceGetMaterialList(){

    },
    edit_show(id) {
      this.cur_materialId = id
    },
    onClickTabItem(item, index) {
      this.currentTabIndex = index;
      this.currentTabValue = item.value;
      this.getMaterialList();
    },
    onClickUseBtn(item) {
      if(this.$store.state.app.addModule_col !== null) {
        this.$message.warning(i18n.t('view_left_sidebar_module_add_material_233'))
        this.$store.commit('left_sidebar/set_active', 'module')
        this.$store.commit('left_sidebar/set_module_tab_active', 'module')
        return
      }
      this.getDetail(item).then(() => {
        this.addMaterialToPage(this.detail)
      })
    },
    onClickConfirmUseBtn() {
      if(this.$store.state.app.addModule_col !== null) {
        this.previewDialogVisible = false
        this.$message.warning(i18n.t('view_left_sidebar_module_add_material_233'))
        this.$store.commit('left_sidebar/set_active', 'module')
        this.$store.commit('left_sidebar/set_module_tab_active', 'module')
        return
      }
      this.previewDialogVisible = false
      let rows = []
      if (Array.isArray(this.detail)) {
        rows = this.detail.map(d =>{
          return this.templet.copy_one_row(JSON.parse(JSON.stringify(d)))
        })
      } else {
        rows = this.templet.copy_one_row(JSON.parse(JSON.stringify(this.detail)))
      }
      this.addMaterialToPage(rows)
      // const new_row = this.templet.copy_one_row(JSON.parse(JSON.stringify(this.detail)));
      // this.addMaterialToPage(new_row)
      // this.scrollToNewLayoutRow() //本来就注释了的
    },
    addMaterialToPage(new_row) {
      const col_id = this.$store.state.app.addModule_col;

      const sel_row_id = $('#u' + col_id).parents('.layout_row').eq(0).attr('data-id')
      const isEmptyRow1 = sel_row_id && !$('#u' + col_id).parents('.layout_row_2').length

      const rowType = $(`#u${sel_row_id}`).attr('rowtype') || 'body';
      const find_obj = this.templet.find_obj(sel_row_id, [rowType]);
      let i
      if (find_obj && isEmptyRow1) {
        i = find_obj.row_index
      } else {
        i = 9999
      }
      if (this.detail) {
        if (this.isFullPage && rowType === 'body') {
          if(Array.isArray(new_row)) {
            this.$store.state.myRender[rowType].push(...new_row);
          } else {
            this.$store.state.myRender[rowType].push(new_row);
          }
        } else {
          if(Array.isArray(new_row)) {
            this.$store.state.myRender[rowType].splice(i, 1, ...new_row);
          } else {
            this.$store.state.myRender[rowType].splice(i, 1, new_row);
          }

          if (!isEmptyRow1) {
            this.scrollToNewLayoutRow()
          }
        }
        this.templet.global_color_for_module()
        if (this.isFullPage) {
          if (window.fullPage) {
            setTimeout(() => {
              window.fullPage.resetData()
              window.fullPage.resetHeight()
              window.fullPage.goLastPage()
            }, 200)
          }
        }
      }
    },
    onClickPreviewBtn(item) {
      this.detail = null
      this.currentMaterial = item
      this.previewDialogVisible = true
      console.log(224, item)
      if (item.isEmpty) {
        this.getDetail(item)
        this.previewImg = ''
        this.$nextTick(() => {
          const ind = parseInt(item.id.split('_')[1]) - 1;
          if (this.$store.state.app.web_language_wm == 'en') {
            this.previewImg = this.emptyTemplatePathEn + 'preview/wm' + ind + '.png'
          } else if (this.$store.state.app.web_language_wm == 'tc') {
            this.previewImg = this.emptyTemplatePathTc + 'preview/wm' + ind + '.png'
          } else {
            this.previewImg = this.emptyTemplatePath + 'preview/wm' + ind + '.png'
          }
        })
      } else {
        this.getDetail(item)
      }
    },
    onClickDeleteBtn(item) {
      this.$confirm(i18n.t('view_material_library_index_54'), '', {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
      }).then(() => {
        del_material({
          id: item.id
        }).then((e) => {
          if (e.code == 200) {
            this.getMaterialList();
          }
        })
      }).catch((e) => {
        console.error(e)
      })
    },
    getMaterialList() {
      if(this.search_content) {
        return this.getNormalMaterialList()
      }
      if (this.isEmptyTemplate) {
        return this.getEmptyMaterialList()
      } else {
        this.getNormalMaterialList()
      }
    },
    getEmptyMaterialList() {
      if(this.emptyTemplateList.length == 0){
        this.getEmptyTemplateList()
      }
      this.list = this.emptyTemplateList
      this.$nextTick(() => {
        this.templet.left_sidebar_draggable()
      })
      return
    },
    getNormalMaterialList() {
      this.listLoading = true;
      return get_material({
        row: 10000,
        pid: this.search_content ? null : this.currentTabValue,
        groupName: this.search_content.trim()
      }).then((e) => {
        if (e.code === 200 && e.data && Array.isArray(e.data)) {
          this.list = e.data;
          if(this.search_content) {
            // 搜索，空白模板和其他类型一起搜
            this.list = [...this.getFilteredEmptyMaterialList(), ...e.data]
          }
        }
        this.$nextTick(() => {
          this.templet.left_sidebar_draggable()
        })
      }).finally(() => {
        this.listLoading = false;
      })
    },
    getFilteredEmptyMaterialList() {
      if(this.emptyTemplateList.length == 0){
        this.getEmptyTemplateList()
      }
      const list = this.emptyTemplateList
      const keyword = this.search_content.trim()
      return list.filter(item => {
        return item.group_name.toLowerCase().includes(keyword.toLowerCase())
      })
    },
    getDetail(option) {
      if (option.isEmpty) {
        return this.getEmptyTemplateDetail(option)
      } else {
        return this.getNormalDetail(option)
      }
    },
    getEmptyTemplateDetail(option) {
      this.detail = this.$utils.createEmptyTemplate(option.scheme)
      return new Promise((r) => {
        r(this.detail)
      })
    },
    getNormalDetail(option) {
      this.detailLoading = true
      return get_material_detailed({
        group_id: option.id
      }).then((e) => {
        if (e.code == 200 && e.data && Array.isArray(e.data) && e.data.length > 0) {
          let obj = null;
          try {
            obj = JSON.parse(e.data[0].params)
            infoData = e.data[0]
          } catch (e) {
            console.error(e)
          }

          if (obj) {
            const sel_row_id = this.$store.state.row.moduleID;
            const type = $(`#u${sel_row_id}`).attr('rowtype') || 'body';
            let rows = []

            // 需求变动，素材以前是一个通栏，是对象，显示变成多个通栏，是数组
            if(Array.isArray(obj)) {
              rows = obj.map(d =>{
                d.rowType = type
                return this.templet.copy_one_row(d)
              })
            } else {
              obj.rowType = type;
              rows = [this.templet.copy_one_row(obj)]
            }

            this.detail = rows
            this.templet.global_color_for_module_make(this.detail)

            // this.detail = this.templet.copy_one_row(obj);
            // this.templet.global_color_for_module_make([this.detail])
          }
        }
      }).finally(() => {
        this.detailLoading = false;
      }).catch((err) => {
        console.error(err)
      })
    },
    scrollToNewLayoutRow() {
      setTimeout(() => {
        $('.layout_body .layout_row').last()[0].scrollIntoView({
          alignToTop: true
        })
      })
    },
    getEmptyTemplateList() {
      let list = emptyTemplateConfig.map((item, index) => {
        let img = ''
        if (this.$store.state.app.web_language_wm == 'en') {
          img = this.emptyTemplatePathEn + '/wm' + (index +1) + '.png';
        } else if (this.$store.state.app.web_language_wm == 'tc') {
          img = this.emptyTemplatePathTc + '/wm' + (index +1) + '.png';
        } else {
          img = this.emptyTemplatePath + '/wm' + (index +1) + '.png'
        }
        return {
          ...item,
          name: i18n.t('view_left_sidebar_module_add_material_234') + (index + 1),
          group_name: i18n.t('view_left_sidebar_module_add_material_234') + (index + 1),
          img: img,
          isEmpty: true,
        }
      })
      this.emptyTemplateList = list
    },
    initTabList() {
      let tabList = this.$store.state.options.group_type_list.slice()
      if (this.emptyTemplateVisible) {
        tabList.unshift({
          value: 'empty',
          label: i18n.t('view_left_sidebar_module_add_material_235')
        })
      }
      if (!this.isDesigner) {
        tabList.unshift({
          value: this.myMaterialId,
          label: this.myMaterialName
        })
      }
      this.tabList = tabList
    },
    clear(){
      this.search_content = ''
      this.initTabList()
      this.onClickTabItem(this.tabList[0], 0)
    },
    canDelete(item) {
      return (this.isDesigner && !this.isEmptyTemplate) || this.isMyMaterial(item)
    },
    isMyMaterial(item) {
      return item.pid === this.myMaterialId
    },
  },
  created() {
    // this.currentTabValue = this.emptyTemplateVisible ? 'empty' : '12'
    this.initTabList()
    this.onClickTabItem(this.tabList[0], 0)
    this.debounceGetMaterialList = debounce(200, false, this.getMaterialList.bind(this))

    // this.currentTabIndex = this.tabList.findIndex(tab => tab.value === this.currentTabValue)
    // this.getEmptyTemplateList()
    // this.getMaterialList()
  },
  mounted() {
    // this.createEmptyTemplate()
  }
}
</script>

<style lang="scss" scoped>

.modular {
  padding: 16px 13px;

  .modular_search{
    /deep/ .el-input__inner{
      padding-left: 40px;
      height: 36px;
      border: 1px solid #e1e1e1;
      border-radius: 36px;
    }
    /deep/ .el-input__prefix .el-input__icon {
      width: 35px;
      line-height: 36px;
      font-size: 18px;
    }
    /deep/ .el-input__suffix .el-input__suffix-inner .el-icon-close{
      margin: 11px 2px;
    }
  }
}

.tab-header {
  padding: 7px 0px 0px 0px;
}

.tab-item {
  padding: 5px 7px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 2px;
  display: inline-block;
  margin: 5px 3px;
}

.tab-item-current {
  color: #0078d7;
  border-color: #0078d7;
}

.section-content {
  padding-bottom: 30px;
}

.material-item {
  margin: 10px 10px;
  box-shadow: 0 2px 11px 2px rgba(204, 204, 204, 0.4);
  position: relative;

  .img-wrapper {
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    min-height: 100px;

    img {
      width: 100%;
      min-height: 160px;
      object-fit: contain;
    }
  }

  .btn-group {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 10;
  }

  .my-btn-delete {
    margin-left: 10px;
  }
}

.bottom-line {
  border-bottom: 1px solid #e0e0e0;
  line-height: 1;
  text-align: center;
  margin-top: 15px;
  margin-left: 10px;
  margin-right: 10px;
}

.bottom-text {
  position: relative;
  top: 0.5em;
  background: #fff;
  padding-left: 5px;
  padding-right: 5px;
}

.preview-wrapper {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  /deep/ .row_edit_frame{
    display: none;
  }

  /deep/ .tooptipPart, /deep/ .module_edit_btn {
    display: none!important;
  }
}

.preview-img-wrapper {
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
}

.img-preview {
  width: 100%;
  max-height: 400px;
}
</style>
<style>
.el-button--danger:hover, .el-button--danger:focus {
  background: #f78989;
  border-color: #f78989;
  color: #FFFFFF;
}
.preview-btn {
  color: #0078d7 !important;
  background-color: #fff !important;
  border-color: #0078d7 !important;
}
.material_thumb_mask {
  position: absolute;
  top: auto;
  left: 10px;
  right: 10px;
  bottom: 15px;
  height: 40%;
  background: linear-gradient(0deg,rgba(0,0,0,.5) 0,transparent);
  border-radius: 2px;
  opacity: .4;
  filter: alpha(opacity=40);
  z-index: 2;
}

.material-name{
  margin-bottom: 5px;
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/module/add_material.vue